import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Helmet } from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: 4rem 0;
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const CharmingCharlie = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: Charming Charlie | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="Charming Charlie"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/charmingcharming_hero.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Clothing</IndustryTag>
            <IndustryTag>Jewelry</IndustryTag>
            <IndustryTag>Accessories</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About Charming Charlie
          </H3>
          <P>
            Since 2004, Charming Charlie has been recognized for leading a retail revolution through an award-winning in-store experience consisting of carefully curated collections that are arranged by color. Realizing that presenting products by color provides and intuitive and fun way of shopping for clothing, handbags, jewelry, and accessories, Charming Charlie partnered with RMG to bring that same award-winning experience online, extending their reach far past their physical stores.
          </P>
          <P>
            By creating innovative site-wide filters for color families, seamlessly integrating their in-store and online rewards and loyalty programs, and syncing their physical inventory systems to their online points-of-sale, RMG helped Charming Charlie delight their online customers with the same experience their in-store customers love.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Platform Delivery</ServiceName>
              <ServiceName>Platform Upgrades</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Strategy</ServiceTag>
              <ServiceName>Business Process Design</ServiceName>
              <ServiceName>Omnichannel Assessment</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/charmingcharlie_img_01.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>Charming Charlie is a one-of-a-kind source of style that's been inspiring women to live more colorfully by offering a wide variety of apparel and fashion accessores in an even wider array of colors, making that perfect look fun and easy to find. As their catalog continues to grow and they introduced more moving parts to their brand - a loyalty program, reward points, and gift cards - they partnered with RMG to ensure their online experience satisfies their customers in the same ways they do in-store. To Charming Charlie, this meant allowing online customers to shop by color, redeem gift cards and rewards they may have earned in store, and keep track of inventory regardless of the point of sale.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>To RMG, this meant standing them up on technology that scales well, integrates with their existing physical infrastructure, and streamlines their current workflows. RMG started by migrating Charming Charlie from Magento 1 to Magento 2. During the data migration, RMG made updates to the ways in which simple and configurable product data was stored, moving to an all-configurable structure. These updates allow for complex cross-family product association and attribute matching - for example, associating products from multiple families when a user filters the whole experience by color, or automatically recommending other products available in the same color(s) the user has in their cart. They also allow Charming Charlie's product teams to perform bulk operations (e.g. add or update many products at once), greatly streamlining catalog administration.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/charmingcharlie_img_02.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/charmingcharlie_img_04.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>By default, Magento doesn't know anything about in-store programs such as gift cards, rward points, promotions, or credits. RMG integrated Charming Charlie's existing in-store programs and CRM with their online experience, allowing customer accounts to span every transaction, regardless of whether it originated in store or online. RMG took the same approach for Charming Charlie's ordering, payment, logistics, and fulfillment solutions by integrating their existing inventory management, customer service, point-of-sale, and shipment solutions with their online store. Implementing and refining these integrations resulted in an immediate drop in out-of-stock listings and shipping issues.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>Another area that RMG greatly streamlined is content publications and product content management. RMG helped Charming Charlie move away from managing content in spreadsheets by implementing custom pre-approved content templates in Magento 2. Doing so provides a centralized workflow in a single system that every team can see in real-time and work on in parallel, greatly reducing time-to-publication and eliminating duplication of efforts. This means that everything from blog posts to product pages could be managed with much fewer resources and much less risk, allowing Charming Charlie to focus more on growing their brand and delighting customers in store and online.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/charmingcharlie_img_04.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <Container>
      <Row>
        <NavCol col={12}>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                        to={`/portfolio/rickshaw-bagworks`}
                        buttonText="Rickshaw Bagworks" />
          <NavSpan>/</NavSpan>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/hum-by-verizon`}
                        buttonText="Hum by Verizon" />
        </NavCol>
      </Row>
    </Container>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useBorderTop
                useArrow
    />
    <PageNavigation prev="capabilities" next="insights" />
  </Fragment>;
};

export default withRouter(CharmingCharlie);